import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ArmstrongContent from "./ArmstrongPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route
            path="/suppliers/armstrong/pumps"
            component={ArmstrongContent}
          />
          <Route path="/suppliers/armstrong">
            <Redirect to="/suppliers/armstrong/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
